import type { App } from "vue"
import VueQrcode from "@chenfengyuan/vue-qrcode"

export function loadVueQrcode(app: App) {
  app.component(VueQrcode.name || "VueQrcode", VueQrcode)
}
